import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      borderRadius: 'inherit',
      background: theme.colors.neutral[0],
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    header: {
      borderTopLeftRadius: 'inherit',
      borderTopRightRadius: 'inherit',
      flexShrink: 0,
    },
    footer: {},
    body: {
      overflowY: 'hidden',
      height: '100%',
    },
    bodyWrapper: {},
  }
})
